import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import Facebook from "../assets/img/social/face.png";
import Instag from "../assets/img/social/insta.png";
import Xsocial from "../assets/img/social/x.png";
import You from "../assets/img/social/you.png";
import iconstrt from "../assets/img/iconstartt.png";
import Whatsaap from "../assets/img/whatsapp.png";
import Whatsaap1 from "../assets/img/whatapp_text.png";
import footer_logo from "../assets/img/footer_logo.png";
import staricon from '../assets/img/starbtn.png';


const Footer = () => {

  const formRef = useRef(null);
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_hmrezop",      // ✅ same service ID
      "template_6qlhzgj",     // ✅ same template ID
      formRef.current,
      "1eblwEiXOqFJO88JY"      // ✅ same public key
    ).then(
      () => {
        setStatus("Message sent successfully!");
        formRef.current.reset();
      },
      () => {
        setStatus("Failed to send message. Please try again.");
      }
    );
  };

  return (
    <>
      <div className="whatsappbtn">
        <a href="https://wa.me/9899604722?text=Hii" target="_blank" rel="noreferrer">
          <img className="whatsaap" src={Whatsaap} alt="Whatsapp" /><img className="whatsaap1" src={Whatsaap1} alt="Whatsapp" />
        </a>
      </div>

      <footer>
        <section className="contact_form_mbr">
          <div className="border_b"></div>
            <span>for exclusive content</span>
            <h2><a href="https://www.instagram.com/bhavna555/">Connect with us on Instagram<span className="footer_icon_arrow">↗</span> </a></h2>
          <div className="container">
            
            <p>
              Get exclusive tips, behind-the-scenes moments, and daily
              confidence<br/> inspiration. Follow Bhavana on Instagram to
              stay updated and motivated.
            </p>

            {/* 🔥 EMAILJS FORM */}
           
           

           

          </div>
           <div className="footer_contents">
            <div className="container">
              <div className="footer_content">
             
              <div className="footer_right">
                <h2>Get in touch</h2>
                   <form
              ref={formRef}
              onSubmit={sendEmail}
              className="contact_form_outer"
            >
              <div className="row">
                <div className="col-sm-6">
                  <input
                    type="text"
                    name="fname"
                    className="form-control"
                    placeholder="Your Name"
                    required
                  />
                </div>

                <div className="col-sm-6">
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Your Email"
                    required
                  />
                </div>

                <div className="col-sm-6">
                  <input
                    type="number"
                    name="phone"
                    className="form-control"
                    placeholder="Your Phone"
                    required
                  />
                </div>

                <div className="col-sm-6">
                  <input
                    type="text"
                    name="inquiry"
                    className="form-control"
                    placeholder="Subject"
                    required
                  />
                </div>

                <div className="col-sm-12">
                  <textarea
                    name="message"
                    className="messageboxx"
                    placeholder="Message"
                  ></textarea>
                </div>
              </div>

              {/* STATUS MESSAGE */}
              {status && (
                <p className="form-status">{status}</p>
              )}

              <button type="submit" className="terrs_btn">
                <img src={iconstrt} alt="" />
                Submit
              </button>
            </form>
              </div>
               <div className="footer_left">
                <img className="footer_logo" src={footer_logo} alt="Whatsapp" />
                <h3>Policies:</h3>
                <ul>
                  <li>
                     <a className="nav-link" href="/terms-and-conditions ">Terms and Conditions</a>
                  </li>
                  <li>
                     <a className="nav-link" href="/privacy-policy">⁠Privacy Policy</a>
                  </li>
                  <li>
                     <a className="nav-link" href="/refund-policy ">Refund Policy with timelines </a>
                  </li>
                  <li>
                     <a className="nav-link" href="/cancellation-policy ">⁠Cancellation Policy </a>
                  </li>
                </ul>
                 <div className="social_link">
              <ul>
                <li>
                  <a href="https://www.facebook.com/TransformwithBhavana555">
                    <img src={Instag} alt="Facebook" />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/bhavana-singh555/">
                    <img src={You} alt="X" />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/bhavna555/">
                    <img src={Xsocial} alt="Instagram" />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@bhavnasingh555">
                    <img src={Facebook} alt="YouTube" />
                  </a>
                </li>
              </ul>
            </div>
              </div>
              </div>
              </div>
            </div>
        </section>
      </footer>
    </>
  );
};

export default Footer;
